import { t } from 'i18next';

import {
  INDUSTRY_CODES,
  type IndustryCode,
} from 'features/conversation-preferences/services/conversation-preferences-service';

/** The 8 industry groups asked before the area: preference code, UILM key, English fallback. */
export const ONBOARDING_INDUSTRY_OPTIONS: {
  code: Exclude<IndustryCode, 'other'>;
  key: string;
  defaultValue: string;
}[] = [
  {
    code: 'finance_insurance',
    key: 'ONBOARDING_INDUSTRY_FINANCE_INSURANCE',
    defaultValue: 'Banking & insurance',
  },
  {
    code: 'industry_manufacturing',
    key: 'ONBOARDING_INDUSTRY_INDUSTRY_MANUFACTURING',
    defaultValue: 'Industry & manufacturing',
  },
  {
    code: 'trade_logistics_consumer',
    key: 'ONBOARDING_INDUSTRY_TRADE_LOGISTICS_CONSUMER',
    defaultValue: 'Trade, logistics & consumer',
  },
  {
    code: 'health_pharma',
    key: 'ONBOARDING_INDUSTRY_HEALTH_PHARMA',
    defaultValue: 'Health & pharma',
  },
  {
    code: 'technology_media',
    key: 'ONBOARDING_INDUSTRY_TECHNOLOGY_MEDIA',
    defaultValue: 'Technology & media',
  },
  {
    code: 'consulting_services',
    key: 'ONBOARDING_INDUSTRY_CONSULTING_SERVICES',
    defaultValue: 'Consulting & services',
  },
  {
    code: 'construction_realestate_energy',
    key: 'ONBOARDING_INDUSTRY_CONSTRUCTION_REALESTATE_ENERGY',
    defaultValue: 'Construction, real estate & energy',
  },
  {
    code: 'public_education',
    key: 'ONBOARDING_INDUSTRY_PUBLIC_EDUCATION',
    defaultValue: 'Public sector & education',
  },
];

/** The free-text field under the chips; its answer is stored as `other` with the user's words. */
export const ONBOARDING_INDUSTRY_OTHER = {
  key: 'ONBOARDING_INDUSTRY_OTHER',
  defaultValue: 'Other industry …',
};

export const isIndustryCode = (value: unknown): value is IndustryCode =>
  INDUSTRY_CODES.includes(value as IndustryCode);

/** The industry in the UI language: the chip label, or the user's own words for `other`. */
export function onboardingIndustryLabel(code?: IndustryCode, text?: string): string {
  if (!code) return '';
  if (code === 'other') return text?.trim() ?? '';
  const option = ONBOARDING_INDUSTRY_OPTIONS.find((item) => item.code === code);
  return option ? t(option.key, { defaultValue: option.defaultValue }) : '';
}
